/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCloudpaymentsStartWidgetPaymentModel,
  ICloudpaymentsStartWidgetPaymentRequest,
  IMappers,
  ICloudpaymentsStartWidgetPaymentResponse,
  ICloudpaymentsStartWidgetPaymentResponseError,
  TCloudpaymentsStartWidgetPaymentResponse,
} from './types';

const defaultConfig: TCloudpaymentsStartWidgetPaymentModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'billing-accounts',
  pathApi: '/v1/cloudpayments/start-widget-payment/',
  hostType: 'api',
} as TCloudpaymentsStartWidgetPaymentModel;

function createCloudpaymentsStartWidgetPaymentModel(
  parameters: ICloudpaymentsStartWidgetPaymentRequest,
): TCloudpaymentsStartWidgetPaymentModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICloudpaymentsStartWidgetPaymentOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICloudpaymentsStartWidgetPaymentRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCloudpaymentsStartWidgetPayment<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICloudpaymentsStartWidgetPaymentOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TCloudpaymentsStartWidgetPaymentResponse
> {
  const { response, statusCode } = await httpApi.fetch(createCloudpaymentsStartWidgetPaymentModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICloudpaymentsStartWidgetPaymentResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICloudpaymentsStartWidgetPaymentResponseError);
    }
  }

  return { response, statusCode } as TCloudpaymentsStartWidgetPaymentResponse;
}

export { defaultConfig, createCloudpaymentsStartWidgetPaymentModel, fetchCloudpaymentsStartWidgetPayment };
